import React from 'react';
import { Row, Col } from 'antd';
import { OrganizationFormItem } from './OrganizationFormItem';
import { WorkstationFormItem } from './WorkstationFormItem';
import { InitialDateFormItem } from './InitialDateFormItem';
import { FinalDateFormItem } from './FinalDateFormItem';
import { CompanyFormItem } from './CompanyFormItem';
import { SectorFormItem } from './SectorFormItem';
import { LineFormItem } from './LineFormItem';
import { AuthorFormItem } from './AuthorFormItem';
import { NameFormItem } from './NameFormItem';
import { LabelLargeSemibold } from '@/components/Settings/DataExtraction/styles';
import { I18n } from '@aws-amplify/core';

export function ModelForm(): JSX.Element {
	return (
		<Row gutter={32}>
			<Col span={24} style={{ marginBottom: 16 }}>
				<LabelLargeSemibold>{I18n.get('General Information')}</LabelLargeSemibold>
			</Col>
			<Col span={12}>
				<Row gutter={[32, 0]}>
					<Col span={24}>
						<OrganizationFormItem />
					</Col>
					<Col span={24}>
						<SectorFormItem />
					</Col>
					<Col span={24}>
						<WorkstationFormItem />
					</Col>
					<Col span={24}>
						<InitialDateFormItem />
					</Col>
					<Col span={24}>
						<AuthorFormItem />
					</Col>
				</Row>
			</Col>
			<Col span={12}>
				<Row gutter={[32, 0]}>
					<Col span={24}>
						<CompanyFormItem />
					</Col>
					<Col span={24}>
						<LineFormItem />
					</Col>
					<Col span={24}>
						<NameFormItem />
					</Col>
					<Col span={24}>
						<FinalDateFormItem />
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
